import { render, staticRenderFns } from "./mfa-settings.vue?vue&type=template&id=fcb4568e&scoped=true&"
import script from "./mfa-settings.vue?vue&type=script&lang=js&"
export * from "./mfa-settings.vue?vue&type=script&lang=js&"
import style0 from "./mfa-settings.vue?vue&type=style&index=0&id=fcb4568e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb4568e",
  null
  
)

export default component.exports